<template>
  <v-container
    class="dashboard"
  >
    <DoubleCard class="top">
      <Condition @start-loader="loader = true" />
    </DoubleCard>

    <DoubleCard
      ref="chartBoard"
      class="chart"
    >
      <PastBarLine
        :daily-visits="getGraphData[0]"
        :daily-amount="getGraphData[1]"
      />
    </DoubleCard>
    <ActionPanel
      :tank-info="getTankInfo"
      :yearly-data="getYearlyData"
      class="action-panel"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ActionPanel, Condition } from './components'
import { PastBarLine } from './components/charts'
import { DoubleCard } from '@/components/ui'

export default {
  components: {
    PastBarLine,
    ActionPanel,
    Condition,
    DoubleCard
  },
  computed: {
    ...mapState('dashboard', ['selectedSpan']),
    ...mapGetters('dashboard', ['getGraphData', 'timeDiff', 'getTankInfo', 'getYearlyData'])
  }
}
</script>
<style lang="scss" scoped>
.dashboard {
  height: 75vh;
  min-height: 610px;
  padding-bottom: 0;
  display: grid;
  grid-template-columns: minmax(560px, 1fr) 290px;
  grid-template-rows: 100px minmax(0, 1fr);
  gap: 9px;
  justify-items: stretch;
  align-items: stretch;
}
.top {
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
}
.chart {
  grid-column: 1 / span 1;
  grid-row: 2 / span 1;
}
.action-panel {
  grid-column: 2 / span 1;
  grid-row: 1 / span 2;
}
</style>
